module.exports = __webpack_public_path__ + "static/media/marketing-ppms.f3fdefb8.webp";